import { BrowserRouter, Route, Routes } from "react-router-dom";

import { useAuth } from "./AuthContext";
import { KioskProvider } from "./KioskContext";
import { PartnerProvider } from "./PartnerContext";
import { PointProvider } from "./PointContext";
import { MemberProvider } from "./MemberContext";
import { NoticeProvider } from "./NoticeContext";
import { CampaignProvider } from "./CampaignContext";
import Auth from "./screens/Auth";
import Dashboard from "./screens/Dashboard";
import Admin from "./screens/Admin";
import Partner from "./screens/Partner";
import Excel from "./screens/Excel";
import Point from "./screens/Point";
import Kiosk from "./screens/Kiosk";
import AdminStats from "./screens/StatsV2";
import Notice from "./screens/Notice";
import MemberStatusV2 from "./screens/MemberStatusV2";
import CampaignV2 from "./screens/CampaignV2";

const App = () => {
    const { user } = useAuth();

    return (
        <>
            {!user ? (
                <Auth />
            ) : (
                <KioskProvider>
                    <PartnerProvider>
                        <MemberProvider>
                            <NoticeProvider>
                                <CampaignProvider>
                                    <BrowserRouter>
                                        <Routes>
                                            <Route path="/dashboard" element={<PointProvider><Dashboard /></PointProvider>}></Route>
                                            <Route path="/" element={<Kiosk />}></Route>
                                            <Route path="/admin" element={<Admin />}></Route>
                                            <Route path="/partner" element={<Partner />}></Route>
                                            <Route path="/excel" element={<Excel />}></Route>
                                            <Route path="/point" element={<PointProvider><Point /></PointProvider>}></Route>
                                            <Route path="/point/withdraw-methods" element={<PointProvider><Point view="methods" /></PointProvider>}></Route>
                                            <Route path="/stats" element={<AdminStats />}></Route>
                                            <Route path="/notice" element={<Notice />}></Route>
                                            <Route path="/members" element={<PointProvider><MemberStatusV2 /></PointProvider>}></Route>
                                            <Route path="/campaigns" element={<CampaignV2 />}></Route>
                                        </Routes>
                                    </BrowserRouter>
                                </CampaignProvider>
                            </NoticeProvider>
                        </MemberProvider>
                    </PartnerProvider>
                </KioskProvider>
            )}
        </>
    );
};

export default App;
